import { FlowBuilder } from '@/features/flow/_builder/flow-builder'
import { getFlowQuery } from '@/queries/flow.query'
import { useFlowStore } from '@/stores/flow-store'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { ReactFlowProvider } from '@xyflow/react'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/flows/$id/edit')({
  component: Flow,
  async loader({ context, params }) {
    await context.queryClient.ensureQueryData(getFlowQuery(+params.id))
  }
})

function Flow() {
  const setWorkflow = useFlowStore((s) => s.actions.setWorkflow)
  const params = Route.useParams()
  const { data } = useSuspenseQuery(getFlowQuery(+params.id));

  useEffect(() => {
    setWorkflow({
      id: +params.id,
      name: data.name,
      nodes: data.workflow.nodes,
      edges: data.workflow.edges,
    })
  }, [setWorkflow])

  return (
    <ReactFlowProvider>
      <FlowBuilder />
    </ReactFlowProvider>
  )
}
